import { useEffect, useRef, useState } from 'react';
import { useStore } from '../../../../utils/store';
import { useNavigate } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import Constants from '../../../../utils/constants';
import HttpService from '../../../../services/HttpService';
import { useSearch } from '../../../../components/searchContext';
import {
  Box,
  Button,
  Checkbox,
  Paper,
  Typography,
  SortDirection,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import AddButtonComponent from '../../../../components/form/AddButtonComponent';
import CustomPaginationActionsTable from '../../../../components/TablePagination';
import { Delete } from '@mui/icons-material';
import FormFieldData from '../../../../Models/FormFieldData';
import SimpleDialogComponent from '../../../../components/SimpleDialogComponent';
import CommonForm from '../../../../components/form/CommonForm';
import IdLabelData from '../../../../Models/IdLabelData';
import {
  currentDatePlusDate,
  downloadFile,
  getFileType,
} from '../../../../utils/storageUtil';
import AlertMessageComponent from '../../../../components/AlertMessageComponent';
import { useAlert } from '../../../../components/alertContext';

interface LabourDocumentsProps {
  labourId: number;
}
const LabourDocuments: React.FC<LabourDocumentsProps> = ({ labourId }) => {
  const { searchQuery } = useSearch();
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();

  const columns: any[] = [
    {
      field: 'id',
      headerName: 'Document',
      renderCell: (value: any, row: any) => (
        <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
          <Checkbox
            edge="start"
            checked={checkedIds.includes(value)}
            tabIndex={-1}
            disableRipple
          />

          <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
            <small>
              {row.document.id}
              {'-'}
            </small>
            {getFileType(row.document.fileName, row.document.id, (id: any) => {
              handleDownloadFile(id);
            })}
          </Box>
        </Box>
      ),
    },
    {
      field: 'expiryDate',
      headerName: 'Expiry',
    },
    {
      field: 'documentTypeName',
      headerName: 'Document Type',
    },

    {
      field: 'notes',
      headerName: 'Notes',
    },

    {
      field: 'id',
      headerName: '',
      disableSort: true,
      renderCell: (value: any, row: any) => (
        <IconButton
          type="button"
          sx={{ p: '10px', color: '#ffffff' }}
          aria-label="inbox"
          onClick={() => {
            handleDelete(value);
          }}
        >
          <Delete />
        </IconButton>
      ),
    },
  ];

  const [paginate, setPaginate] = useState<any>({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [currentId, setCurrentId] = useState<number | string>(0);
  const [documentTypeList, setDocumentTypeList] = useState<IdLabelData[]>([]);
  const [addNewDialogOpen, setAddNewDialogOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [checkedIds, setCheckedIds] = useState<any[]>([]);
  const [rows, setRows] = useState<any>([]);
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('desc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  type formData = {
    [k: string]: { required: boolean; value: any };
  };
  const handleDownloadFile = async (ID: any) => {
    const media: any = await getMediaRecord(ID);
    if (media) {
      window.open(media, '_blank');
    }
  };
  const handleSelectedIds = async (id: any) => {
    console.log(id);
    setCheckedIds((prevItems: any) => {
      const newItems = [...prevItems];
      if (!newItems.includes(id)) {
        newItems.push(id);
      } else {
        newItems.splice(newItems.indexOf(id), 1);
      }
      return newItems;
    });
  };
  const handleDelete = async (ID: any) => {
    const reqData: any = {
      status: '0',
      id: ID,
    };
    const endpoint = `${Constants.apiURL + Constants.documentURL}/labour`;
    let response: any;
    try {
      response = await HttpService.patch(endpoint, reqData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });

      if (response.success) {
        fetchData();
      }
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const handleDownloadAll = async (IDs: any) => {
    const endpoint = `${Constants.apiURL + Constants.documentPDFsURL}/labour/${labourId}`;
    let response: any;
    try {
      setIsDownloading(true);
      response = await HttpService.get(
        endpoint,
        {
          headers: {
            Authorization: `Bearer ${getAdmin()}`,
            Accept: 'application/pdf',
          },

          responseType: 'blob',
        },
        { documentIds: IDs }
      );

      if (response) {
        downloadFile(response, `labour_${labourId}.pdf`);
        setIsDownloading(false);
      }
    } catch (error: any) {
      setIsDownloading(false);
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const getMediaRecord = async (id: any) => {
    return new Promise(async (resolve, reject) => {
      const response = await HttpService.get(
        Constants.apiURL + Constants.documentURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { id: id }
      );
      if (response.success) {
        resolve(response.data);
      } else {
        resolve(null);
      }
    });
  };
  const [form, setForm] = useState<formData>({
    id: { required: false, value: null },
    documentTypeId: { required: true, value: null },
    expiryDate: { required: true, value: currentDatePlusDate(2, 0, 0) },
    notes: { required: true, value: '' },
    documentFile: { required: true, value: [] },
  });
  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      if (documentTypeList.length === 0) fetchDocumentTypes();
    }
  }, [labourId]);
  const clearForm = () => {
    setForm({
      id: { required: false, value: null },
      documentTypeId: { required: true, value: 0 },
      expiryDate: { required: true, value: '' },
      notes: { required: true, value: '' },
      documentFile: { required: true, value: [] },
    });
    setAddNewDialogOpen(false);
    fetchData();
  };
  const fetchDocumentTypes = async () => {
    try {
      const URL = `${Constants.apiURL}${Constants.refBundleURL}/fetchDocumentTypes`;
      const response = await HttpService.get(
        URL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { type: 'labour' }
      );
      if (response.data) {
        setDocumentTypeList(response.data);
      }

      console.log('GET Response:', response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleFileChange = (file: any) => {
    setForm((prev: any) => {
      return {
        ...prev,
        documentFile: { required: prev['documentFile'].required, value: file },
      };
    });
  };

  const handleRemove = (file: any) => {
    setForm((prev: any) => {
      return {
        ...prev,
        documentFile: { required: prev['documentFile'].required, value: [] },
      };
    });
  };
  const AddDialogContent = () => {
    return (
      <Box style={{ width: '800px' }}>
        <CommonForm
          singlePage={true}
          fields={formFields}
          onCancel={() => {}}
          formReset={clearForm}
          formTitle={'Add New Document'}
          isLoading={isLoading}
          isUpdate={currentId !== 'Add' ? true : false}
          onSave={handleSave}
          actionButtonPosition="bottom"
        />
      </Box>
    );
  };

  const handleSave = async () => {
    try {
      if (form.documentFile.value.length === 0) {
        setAlert({
          type: 'error',
          message: 'No document files',
          open: true,
        });
        return false;
      }
      const file: any = form.documentFile.value[0];
      if (file) {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('documentTypeId', form.documentTypeId.value);
        formData.append('expiryDate', form.expiryDate.value);
        formData.append('notes', form.notes.value);
        formData.append('file', file);
        const token = getAdmin();
        const signedData: any = await HttpService.handlePresignedDocument(
          file,
          'labour',
          labourId,
          token
        );
        console.log(`signedData`);
        console.log(signedData);
        console.log(`signedData`);
        const response: any = await HttpService.post(
          Constants.apiURL + Constants.documentURL + '/labour?id=' + labourId,
          {
            documentTypeId: form.documentTypeId.value,
            notes: form.notes.value,
            expiryDate: form.expiryDate.value,
            filePath: signedData.filePath,
            fileName: signedData.fileName,
          },
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        );
        if (response.success) {
          setIsLoading(false);
          clearForm();
        }
        console.log('GET Response:', response);
      }
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleStatus = (row: any) => {
    handleSelectedIds(row.id);
  };

  const handlePagination = (paginationData: any) => {
    console.log(paginationData);
    setPaginate(paginationData);
  };

  const fetchData = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL}${Constants.documentURL}/labour`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          id: labourId,
          search: searchQuery,
          limit: paginate.limit,
          offset: paginate.offset,
        }
      );
      if (response.success) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
        handleOrderBy('id');
      }
      console.log('GET Response:', response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };
  const handleExpiryDate = (value: any) => {
    const expiryDateValue =
      value.year() + '-' + (value.month() + 1) + '-' + value.date();
    setForm((prev: any) => {
      return {
        ...prev,
        expiryDate: {
          required: prev['expiryDate'].required,
          value: expiryDateValue,
        },
      };
    });
  };
  useEffect(() => {
    if (searchQuery || paginate || isInitialLoad.current) {
      fetchData();
    }
    isInitialLoad.current = false;
  }, [searchQuery, paginate]);
  const formFields: FormFieldData[] = [
    {
      name: 'documentTypeId',
      label: 'Document Type',
      value: form.documentTypeId.value,
      onChange: handleInputChange,
      isRequired: form.documentTypeId.required,
      size: 6,
      type: 'selectField',
      options: documentTypeList,
      validationRules: [
        (value) => (!value ? 'Document Type is required' : null),
      ],
    },
    {
      name: 'expiryDate',
      label: 'Expiry/Review Date',
      value: form.expiryDate.value,
      onChange: handleExpiryDate,
      isRequired: true,
      type: 'datepicker',
      size: 6,
      validationRules: [
        (value) => (!value ? 'Expiry/Review Date is required' : ''),
      ],
      keyname: 'expiryDate',
    },
    {
      name: 'notes',
      label: 'Notes',
      value: form.notes.value,
      minRows: 5,
      onChange: handleInputChange,
      isRequired: false,
      size: 12,
      type: 'textareaField',
    },
    {
      onChange: handleFileChange,
      value: form.documentFile.value,
      name: 'documentFile',
      isRequired: false,
      label: 'Document File',
      multiple: false,
      type: 'file',
      size: 12,
      existingFiles: [],
      onRemoveFile: handleRemove,
      onRemoveExistingFile: (file: any) => {
        //handleRemoveFileUpdate(file, 'resource_product');
      },
      onOpenFile: (id) => {
        // handleDownloadFile(id);
      },
    },
  ];
  return (
    <div className="containergrid">
      <div className="mt-2">
        <Paper sx={{ width: '100%' }} className="mt-4">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px',
              mb: 2,
            }}
          >
            <Typography variant="h6">Documents</Typography>
            <Box>
              <AddButtonComponent
                onClick={() => {
                  setCurrentId('Add');
                  setAddNewDialogOpen(true);
                }}
                keyName="checkIcon"
                label="Add new"
              />
              <Button
                style={{
                  textDecoration: 'none',
                  textTransform: 'capitalize',
                  color: 'rgba(0, 244, 255, 1)',
                  background: 'rgb(1, 1, 1)',
                  marginLeft: 3,
                }}
                variant="contained"
                disabled={isDownloading}
                startIcon={
                  <DownloadIcon sx={{ color: 'rgba(0, 244, 255, 1)' }} />
                }
                onClick={() => {
                  if (checkedIds.length > 0)
                    handleDownloadAll(checkedIds.join(','));
                  console.log(checkedIds);
                }}
              >
                {isDownloading ? 'Downloading...!' : 'Download'}
              </Button>
            </Box>
          </Box>
          <CustomPaginationActionsTable
            rows={rows}
            columns={columns}
            totalRecords={totalRecords}
            handlePagination={handlePagination}
            handleRowClick={(row) => {
              console.log('row-clicked');
              //   navigate('/data-management/labour/' + row.id);
              //console.log(data);
            }}
            paginationModel={{
              page: paginate.offset,
              pageSize: paginate.limit,
            }}
            handleStatus={handleStatus}
            order={order}
            orderBy={orderBy}
            handleOrderBy={handleOrderBy}
          />
          <SimpleDialogComponent
            title={''}
            dialogContent={AddDialogContent()}
            open={addNewDialogOpen}
            handleClose={() => {
              setAddNewDialogOpen(false);
            }}
          />
          <AlertMessageComponent
            type={alert.type}
            open={alert.open}
            handleClose={handleCloseAlert}
            message={alert.message}
          />
        </Paper>
      </div>
    </div>
  );
};

export default LabourDocuments;
